import { useEffect, useState } from 'react'
import styles from './index.scss'
import AddCommodityList from './list'
import { RightOutline } from 'antd-mobile-icons'
import { DpBusinessPopup, DpFlex, DpButtonThemeConfig } from '@/libs/components'
import differenceBy from 'lodash/differenceBy'

export interface RecordType {
  exchangePrice?: string
  id: string
  skuImage?: string
  listViewUrl?: string
  proName?: string
  specDetail?: string
  specProDetail?: string
  [key: string]: any
}

export interface IDpBusinessCommodityAddCommodity {
  value: RecordType[]
  data: RecordType[]
  onChange: any
  num: number
  maxLength?: number
  rowKey?: string
  [key: string]: any
}

export default function AddCommodity(props: IDpBusinessCommodityAddCommodity) {
  const [visible, updateVisible] = useState(false)
  const [modalValue, updateModalValue] = useState<RecordType[]>([])
  const [sortList, updateSortList] = useState<RecordType[]>([])
  const rowKey = props?.rowKey || 'id'
  
  const _onChange = (item: RecordType, callback?: any, value?: RecordType[]) => {
    if ((value || props?.value || [])?.find(_item => _item?.[rowKey] === item?.[rowKey])) {
      (callback || props?.onChange)?.((value || props?.value || [])?.filter(_item => _item?.[rowKey] !== item?.[rowKey]))
    } else {
      (callback || props?.onChange)?.((value || props?.value || [])?.concat([item]))
    }
  }
  const addTotalFn = (props?.value || []).reduce((_: number, o: any) => {
    _ = _ + Math.round(o?.exchangePrice * 100)
    return _
  }, 0)

  const transformSortList = (value?: RecordType[]) => {
    const noSelectList = differenceBy(props?.data || [], value || props?.value || [], rowKey)
    updateSortList([...(value || props?.value || []), ...noSelectList])
  }

  useEffect(() => {
    transformSortList()
  }, [props?.data])
  
  return (
    <div className={styles["dp-business-commodity--add"]}>
      <DpFlex type='spaceBetween' style={{ paddingBottom: 8 }}>
        <DpFlex.Item>
          <span className={styles["dp-business-commodity--add-title"]}>{lang['加项服务']}</span>
        </DpFlex.Item>
        <DpFlex.Item>
          <span 
            onClick={() => {
              updateVisible(!visible)
              updateModalValue(props?.value)
            }}
          >
            {
              props?.value?.length > 0 ? `已选${props?.value?.length}项 合计` : `${props?.data?.length}项可选`
            }
            {props?.value?.length > 0 && <span className={styles['dp-business-commodity--add-price']}>￥{(addTotalFn / 100).toFixed(2)}</span>}
          </span>
          <RightOutline />
        </DpFlex.Item>
      </DpFlex>
      <AddCommodityList
        {...props}
        maxLength={3}
        data={sortList}
        onChange={_onChange}
      />
      <DpBusinessPopup
        title={lang['加项服务']}
        visible={visible}
        onClose={() => updateVisible(!visible)}
        headerStyle={{ borderBottomWidth: 0, color: 'var(--third-text-color)' }}
        titleStyle={{
          color: 'var(--primary-text-color, #222222)',
          textAlign: 'center',
        }}
        popupBodyStyles={{
          ...props?.customStyles,
          background: `var(--page-bg-color, #f5f6f8)`,
        }}
        containerStyles={{
          background: `var(--content-bg-color, #ffffff)`,
          borderRadius: '16px',
          margin: '0 10px 10px',
        }}
        footer={
          <>
            <div className={styles['dp-business-commodity--add-footer']}>
              <DpButtonThemeConfig
                buttonText={props?.submitText || lang['确 定']}
                isTheme={props?.isTheme}
                onClick={() => {
                  updateVisible(!visible)
                  transformSortList(modalValue)
                  props?.onChange?.(modalValue)
                }}
                style={props?.buttonStyles}
                btnProps={{
                  shape: "rounded",
                  block: true,
                  ariaLabel: props?.submitText || lang['确 定']
                }}
                className={styles['commonSpecsPopup-button']}
              />
            </div>
          </>
        }
      >
        <AddCommodityList
          {...props}
          value={modalValue}
          rowKey={rowKey}
          data={sortList}
          onChange={(item: RecordType) => _onChange(item, updateModalValue, modalValue)}
        />
      </DpBusinessPopup>
    </div>
  )
}
